var map = {
	"./camera.png": "63bb",
	"./detail.png": "a0ac",
	"./home.png": "297d",
	"./inbox.png": "8e36",
	"./inspection.png": "d88f",
	"./pencil.png": "cb86",
	"./spy.png": "ec1e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";